import * as React from "react"

const SvgLogout = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19.714v-14q0-.824.587-1.412A1.93 1.93 0 0 1 5 3.714h6a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287H5v14h6a.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287zm12.175-8H10a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h7.175L15.3 9.84a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.312.95.95 0 0 1 .725.287l3.575 3.575q.3.3.3.7t-.3.7l-3.575 3.575a.93.93 0 0 1-.713.288 1.02 1.02 0 0 1-.712-.313.97.97 0 0 1-.263-.712.98.98 0 0 1 .288-.688z" />
  </svg>
)
export default SvgLogout
